import { getMetadata, getStorage, listAll, ref } from 'firebase/storage';
import { FileTag } from '../types';

export type FolderTagStatus = {
    allFilesTagged: boolean;
    checkedFiles: number;
    untaggedFiles: string[];
    error?: string;
};

export const getFolderTagStatus = async (path: string, kycID?: string): Promise<FolderTagStatus> => {

    const storage = getStorage();
    const listRef = ref(storage, path);

    try {
        const files = await listAll(listRef);
        const untaggedFiles: string[] = [];
        let checkedFiles = 0;

        for (const file of files.items) {
            const metadata = await getMetadata(file);
            // Fund confirmation letters are position documents, not KYC
            // evidence, and must not block review for missing KYC tags.
            if (metadata.customMetadata?.docType === 'fund_confirmation_letter') {
                continue;
            }
            let isFileTagged = false;

            // Skip files tied to a different KYC record.
            if (kycID && metadata.customMetadata && metadata.customMetadata['kycID'] && metadata.customMetadata['kycID'] !== kycID) {
                continue;
            }

            checkedFiles += 1;

            for (const tag of Object.values(FileTag)) {
                if (metadata.customMetadata && metadata.customMetadata[tag] === 'true') {
                    isFileTagged = true;
                    break;
                }
            }

            if (!isFileTagged) {
                untaggedFiles.push(file.name);
            }
        }

        return {
            allFilesTagged: untaggedFiles.length === 0,
            checkedFiles,
            untaggedFiles,
        };
    } catch (error) {
        console.error('Error checking kyc folder files metadata:', error);
        return {
            allFilesTagged: false,
            checkedFiles: 0,
            untaggedFiles: [],
            error: error instanceof Error ? error.message : 'Unknown storage error',
        };
    }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default async (path: string, kycID?: string) => {
    const result = await getFolderTagStatus(path, kycID);
    return result.allFilesTagged;
};
